import React, { Component } from 'react'
import "./Cards.css";
export class Cards extends Component {
    render() {
        return (
            <div className=" card testinomialCards col-10 ">
                <h1 className="ctext">Our clients who are ready to use AirBook</h1>                                                             
                {/* <h1 className="cardt"> have joined us</h1>  */}
                <marquee behavior="alternate" direction="left" className="card-container card-container-wrap">	
                <img className="card-image blurimg me-2" alt="redcafe" src="https://www.cbit.ac.in/wp-content/themes/CBIT/images/event-post.jpg"></img>
                <img className="card-image" alt="redcafe" src="https://www.static-contents.youth4work.com/university/Documents/Colleges/newsEvent/63efa039-222a-42f1-ac53-fb83c26bcb0e.jpg"></img>
                <img className="card-image blurimg ms-2" alt="redcafe" src="https://sriit.ac.in/imagepics/mec1.png"></img>
                </marquee>
            </div>
            
        )
    }
}

export default Cards